import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { useCart } from "../context/CartContext";
import {
  FaCheckCircle,
  FaSpinner,
  FaTruck,
  FaStore,
  FaExclamationTriangle,
} from "react-icons/fa";

function OrderSuccessPage() {
  const { clearCart } = useCart();
  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get("transactionId");

  const [status, setStatus] = useState("verifying");
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    clearCart();
    window.scrollTo(0, 0);

    if (transactionId) {
      verifyPayment(transactionId);
    } else {
      setStatus("success");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verifyPayment = async (id) => {
    try {
      const res = await fetch("/api/payment/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ transactionId: id }),
      });
      const data = await res.json();

      if (data.success) {
        setStatus("success");
        if (data.order) {
          setOrderData(data.order);
        }
      } else {
        console.warn("Verification warning:", data.message);
        setStatus("error");
      }
    } catch (error) {
      console.error("Verification error:", error);
      setStatus("error");
    }
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  // --- UPDATED DELIVERY DISPLAY LOGIC ---
  const getDeliveryDisplay = () => {
    if (!orderData)
      return {
        title: "Estimated Delivery",
        text: "Processing...",
        icon: <FaTruck />,
      };

    const method = orderData.customer.deliveryMethod || "";
    const methodLower = method.toLowerCase();

    // 1. SPECIFIC PICKUP: DUKAMO BHERAWI
    if (methodLower.includes("bherawi")) {
      return {
        title: "Pickup Location",
        text: "Dukamo Bherawi",
        icon: <FaStore style={{ fontSize: "2rem", color: "#999" }} />,
      };
    }

    // 2. SPECIFIC PICKUP: DUKAMO BOLE
    if (methodLower.includes("bole")) {
      return {
        title: "Pickup Location",
        text: "Dukamo Coffee Bole",
        icon: <FaStore style={{ fontSize: "2rem", color: "#999" }} />,
      };
    }

    // 3. SPECIFIC PICKUP: JACROS
    if (methodLower.includes("jacros") || methodLower.includes("buncho")) {
      return {
        title: "Pickup Location",
        text: "Buncho Coffee Jacros",
        icon: <FaStore style={{ fontSize: "2rem", color: "#999" }} />,
      };
    }

    // 4. GENERAL PICKUP (Fallback)
    // Checks for "pick" to catch both "Pickup" and "Pick Up"
    if (methodLower.includes("pick")) {
      return {
        title: "Pickup Location",
        text: method, // Use the full string sent from DeliveryOptionsPage (e.g. "Dukamo Bherawi")
        icon: <FaStore style={{ fontSize: "2rem", color: "#999" }} />,
      };
    }

    // 5. HAWASSA DELIVERY
    if (methodLower.includes("hawassa")) {
      return {
        title: "Estimated Delivery",
        text: "3 - 5 Days",
        icon: <FaTruck style={{ fontSize: "2rem", color: "#999" }} />,
      };
    }

    // 6. UNITED STATES DELIVERY
    if (
      methodLower.includes("united states") ||
      methodLower.includes("usa") ||
      methodLower.includes("us delivery")
    ) {
      return {
        title: "Estimated Delivery",
        text: "5 - 15 Days",
        icon: <FaTruck style={{ fontSize: "2rem", color: "#999" }} />,
      };
    }

    // 7. ADDIS ABABA / DEFAULT
    return {
      title: "Estimated Delivery",
      text: "2 - 3 Days",
      icon: <FaTruck style={{ fontSize: "2rem", color: "#999" }} />,
    };
  };

  const displayInfo = getDeliveryDisplay();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#000",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      <Navbar />

      <div
        style={{
          width: "100%",
          maxWidth: "800px",
          margin: "0 auto",
          padding: "140px 20px 100px",
          textAlign: "center",
          boxSizing: "border-box",
          flex: "1 0 auto",
        }}
      >
        {status === "verifying" && (
          <div style={{ marginTop: "50px" }}>
            <FaSpinner
              className="fa-spin"
              style={{ fontSize: "4rem", color: "#ccc", marginBottom: "20px" }}
            />
            <h1>Verifying Payment...</h1>
            <p style={{ color: "#999" }}>
              Please wait while we confirm your transaction with SantimPay.
            </p>
          </div>
        )}

        {status === "success" && (
          <div style={{ animation: "fadeIn 0.5s ease-in" }}>
            <FaCheckCircle
              style={{
                fontSize: "5rem",
                color: "#4caf50",
                marginBottom: "20px",
              }}
            />
            <h1
              style={{
                fontFamily: "'Source Serif 4', serif",
                fontSize: "2.5rem",
                margin: "0 0 10px 0",
              }}
            >
              Order Confirmed!
            </h1>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#ccc",
                margin: "0 auto 40px",
                lineHeight: "1.6",
              }}
            >
              Thank you for shopping with Dukamo Coffee. Your payment has been
              received securely.
            </p>

            {/* --- ORDER DETAILS BOX --- */}
            <div
              style={{
                backgroundColor: "#111",
                padding: "30px",
                borderRadius: "8px",
                border: "1px solid #333",
                width: "100%",
                marginBottom: "50px",
                textAlign: "left",
                boxSizing: "border-box",
              }}
            >
              {/* --- DYNAMIC DELIVERY/PICKUP INFO --- */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  marginBottom: "20px",
                  borderBottom: "1px solid #222",
                  paddingBottom: "20px",
                }}
              >
                {displayInfo.icon}
                <div>
                  <h3 style={{ margin: 0, color: "#fff", fontSize: "1.2rem" }}>
                    {displayInfo.title}
                  </h3>
                  <p
                    style={{
                      margin: "5px 0 0",
                      color: "#4caf50",
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                    }}
                  >
                    {displayInfo.text}
                  </p>
                </div>
              </div>
              {/* ---------------------------------- */}

              <p style={{ color: "#777", fontSize: "0.9rem", margin: 0 }}>
                Transaction Reference: <br />
                <span
                  style={{
                    color: "#fff",
                    fontFamily: "monospace",
                    fontSize: "1.1rem",
                    wordBreak: "break-all",
                  }}
                >
                  {transactionId || "N/A"}
                </span>
              </p>
            </div>

            <button
              onClick={handleGoHome}
              style={{
                display: "inline-block",
                backgroundColor: "#fff",
                color: "#000",
                padding: "18px 50px",
                border: "none",
                fontWeight: "bold",
                textTransform: "uppercase",
                fontFamily: "'Source Serif 4', serif",
                borderRadius: "4px",
                cursor: "pointer",
                boxShadow: "0 4px 15px rgba(255,255,255,0.15)",
                fontSize: "1rem",
                transition: "transform 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              Return Home
            </button>
          </div>
        )}

        {status === "error" && (
          <div style={{ marginTop: "50px" }}>
            <FaExclamationTriangle
              style={{
                fontSize: "4rem",
                color: "#ff9800",
                marginBottom: "20px",
              }}
            />
            <h1 style={{ color: "#fff" }}>Verification Pending</h1>
            <p
              style={{ color: "#ccc", marginBottom: "20px", lineHeight: "1.6" }}
            >
              We couldn't automatically verify the status immediately, but your
              order has been recorded. Please check your email for confirmation.
            </p>
            <div
              style={{
                backgroundColor: "#1a1a1a",
                padding: "15px",
                borderRadius: "4px",
                marginBottom: "40px",
                border: "1px solid #333",
                display: "inline-block",
              }}
            >
              <p style={{ color: "#777", margin: 0, fontSize: "0.9rem" }}>
                Order Ref:{" "}
                <span style={{ color: "#fff", fontFamily: "monospace" }}>
                  {transactionId}
                </span>
              </p>
            </div>
            <br />
            <button
              onClick={handleGoHome}
              style={{
                display: "inline-block",
                backgroundColor: "#333",
                color: "#fff",
                padding: "15px 40px",
                border: "1px solid #555",
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Return Home
            </button>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default OrderSuccessPage;
